import { useLocation } from 'react-router-dom';
import { Container, Row, Col, Card } from 'react-bootstrap';

const PaymentSuccess = () => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const sessionId = searchParams.get('session_id');

    return (
        <Container className="mt-4">
            <Row className="justify-content-center">
                <Col md={8} lg={6}>
                    <Card className="p-4">
                        <h2 className="mb-3">Payment successful 🎉</h2>
                        <p>Thank you! Your payment has been processed.</p>

                        {sessionId && (
                            <p className="text-muted mb-0">
                                <strong>Session ID:</strong> {sessionId}
                            </p>
                        )}
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default PaymentSuccess;
